import React from 'react'
// @ts-ignore
import { Table as NbTable } from '@netbasequid/core'
import { ColDef, TableContext } from './types'

const FooterRenderer = ({
  testId,
  colDef,
  context,
  customRender: customRenderFromProps
}: {
  testId?: string
  colDef: ColDef<any, any, any>
  context: TableContext<any>
  customRender?: (context: TableContext<any>) => React.ReactNode
}): React.ReactElement => {
  const { customFooterRender: customFooterRenderFromColDef, footerProps, children } = colDef
  const customFooterRender = customRenderFromProps || customFooterRenderFromColDef
  const { colspan, className, style, contentStyle } = footerProps || {}
  const defaultColspan = children?.length || 1

  return (
    <NbTable.TableFooter
      testId={testId}
      colspan={colspan || defaultColspan}
      className={className}
      style={style}
      contentStyle={contentStyle}>
      {customFooterRender?.(context) || ''}
    </NbTable.TableFooter>
  )
}

export default FooterRenderer
